import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class FoyerService {
	constructor(private http: HttpClient) { }

	new(_form: any, _options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.foyer:new',
			params: {
				form: _form,
				options: _options
			}
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	addTiersToFoyer(_form: any, _options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.foyer:addTiersToFoyer',
			params: {
				form: _form,
				options: _options
			}
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getRelations(tiers1: any, tiers2: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.foyer:getRelations',
			params: {
				tiers1: tiers1,
				tiers2: tiers2,
				options: options
			}
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
